const initialState = [];

function reducer(state = initialState, action) {
    if (action.type === 'LOGOUT_REQUEST' || action.type === 'AUTHENTICATE_REQUEST') {
        return initialState;
    }

    if (action.type === 'CLIENT_API_KEYS_SUCCESS') {
        return action.payload;
    }

    if (action.type === 'DELETE_CLIENT_API_KEY_SUCCESS') {
        return state.filter(apiKey => apiKey.id !== action.actionParams.id);
    }

    if (action.type === 'GENERATE_CLIENT_API_KEY_SUCCESS') {
        return [...state, action.payload];
    }

    return state;
}

export default reducer;
